/** Lightweight GA4 event helper. Safe to call during SSR (no-ops on the server). */
type GtagWindow = Window & { gtag?: (...args: unknown[]) => void };

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  (window as GtagWindow).gtag?.("event", name, params);
}

/** Click tracking for the Medical / Surgical weight-loss CTA pair. */
export function trackWeightLossCtaClick(
  category: "medical" | "surgical",
  destination: string,
  location = "cta_pair",
) {
  trackEvent("weight_loss_cta_click", {
    cta_category: category,
    cta_label: category === "medical" ? "Medical Weight Loss" : "Bariatric Surgery",
    cta_location: location,
    link_url: destination,
    page_path: typeof window !== "undefined" ? window.location.pathname : undefined,
  });
}
